import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface ConsulateCategoriesComponentProps {
  disabled: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const categories = Object.freeze([
  {
    id: '1',
    value: 'Prima categoria',
  },
  {
    id: '2',
    value: 'Seconda categoria',
  },
]);

const ConsulateCategoriesComponent = ({
  disabled,
  onChange,
  value,
  error,
}: ConsulateCategoriesComponentProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="category-label">
        Categoria *
      </InputLabel>
      <PmiSelect
        labelId="category-label"
        id="category"
        name="category"
        value={value}
        label="Categoria *"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {categories.map((category: ItemVM) => (
          <MenuItem key={category.id} value={category.id}>
            {category.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ConsulateCategoriesComponent.displayName = 'Consulate category component';

const ConsulateCategories = memo(
  ConsulateCategoriesComponent
) as typeof ConsulateCategoriesComponent;

export default ConsulateCategories;
